// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3w8eR","topBottomGutter":"Layout_topBottomGutter__28CJd"};